import axios from 'axios/index'
import store from './store.js'

const origin = () => {
  if (/localhost|192.168|test.gosnappy/.test(window.location.href))
    return 'https://test.gosnappy.io/v1'
  return 'https://gosnappy.io/v1'
}

const SNAPPY_API = axios.create({
  baseURL: origin()
})

const requestInterceptor = {
  success: (config) => {
    config.headers['app-name'] = 'OWA'
    config.headers['Content-Type'] = 'application/json'

    // Avoid CORS issue by only using this with prod
    if (origin().includes('https://gosnappy'))
    config.headers['cache-control'] = 'no-cache'

    if (store.state.storeId)
      config.headers['storeId'] = store.state.storeId

    if (store.state.groupId)
      config.headers['groupId'] = store.state.groupId

    config.headers['Accept-Language'] = window.i18n.locale.substring(0, 2)

    if (store.state.authorizationId && store.state.authorizationId != 'null') {
      config.headers['authorization'] = store.state.authorizationId
    } else if (store.state.user && store.state.user.authToken != null) {
      config.headers['authorization'] = store.state.user.authToken
    }


    return config
  },
  error: (error) => {
    return Promise.reject(error)
  }
}

const responseInterceptor = {
  success: (response) => {
    return response
  },
  error: (error) => {
    const { errorCode } = error.response.data

    // handle auth token expired or invalid (log them out)
    if (errorCode == 'GENERAL_ERR_INVALID_OR_MISSING_AUTHORIZATION' || errorCode == 'USR_ERR_0030') {
      store.commit('setAuthUser', null)
      store.commit('setAuthToken', null)
    }

    return Promise.reject(error)
  }
}

SNAPPY_API.interceptors.request.use(requestInterceptor.success, requestInterceptor.error)
SNAPPY_API.interceptors.response.use(responseInterceptor.success, responseInterceptor.error)

export const api = SNAPPY_API
